(() => {
  const ADD_URL = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
  const CHANGE_URL = (window.routes && window.routes.cart_change_url) ? window.routes.cart_change_url : '/cart/change.js';
  const CART_URL = '/cart.js';

  const cartState = new Map(); // variantId -> { key, quantity }
  const debounceTimers = new WeakMap();

  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

  function getRules(container){
    const min = parseInt(container.dataset.qtyMin || '1', 10);
    const inc = parseInt(container.dataset.qtyInc || '1', 10);
    const maxRaw = container.dataset.qtyMax;
    const max = maxRaw ? parseInt(maxRaw, 10) : Infinity;
    return { min, inc, max };
  }

  function normalizeQty(rawQty, rules){
    let qty = Number.isFinite(rawQty) ? rawQty : 0;
    qty = Math.max(0, Math.floor(qty));

    if (qty === 0) return 0;

    // respeta min / max
    qty = clamp(qty, rules.min, rules.max);

    // respeta increment: valores permitidos = min, min+inc, min+2inc...
    if (rules.inc > 1) {
      const steps = Math.floor((qty - rules.min) / rules.inc);
      qty = rules.min + steps * rules.inc;
      qty = clamp(qty, rules.min, rules.max);
    }

    return qty;
  }

  function setLoading(container, isLoading){
    container.dataset.loading = isLoading ? '1' : '0';
    container.querySelectorAll('button, input').forEach(el => el.disabled = isLoading);
  }

  function updateCardUI(container, qty){
    const input = container.querySelector('[data-qty-input]');
    const minus = container.querySelector('[data-qty-minus]');
    if (input) input.value = String(qty);
    if (minus) minus.disabled = qty <= 0;
  }

  function updateCartBubble(cart){
    const count = cart?.item_count ?? 0;

    const selectors = [
      '[data-cart-count]',
      '.cart-count-bubble span[aria-hidden="true"]',
      '.cart-count-bubble span',
      '.header__cart-count',
      '.cart-count'
    ];

    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (el) { el.textContent = String(count); break; }
    }

    // Eventos genéricos (algunos temas escuchan esto)
    window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  async function fetchCart(){
    const res = await fetch(CART_URL, { headers: { 'Accept': 'application/json' }});
    const cart = await res.json();

    cartState.clear();
    cart.items.forEach(item => {
      cartState.set(String(item.variant_id), { key: item.key, quantity: item.quantity });
    });

    document.querySelectorAll('[data-quick-qty]').forEach(container => {
      const variantId = container.getAttribute('data-variant-id');
      const current = cartState.get(String(variantId));
      updateCardUI(container, current ? current.quantity : 0);
    });

    updateCartBubble(cart);
    return cart;
  }

  async function addToCart(variantId, quantity){
    const res = await fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity) }] })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data?.description || data?.message || 'No se pudo agregar al carrito');
    return fetchCart(); // add.js no siempre devuelve carrito completo
  }

  async function changeCart(lineKey, quantity){
    const res = await fetch(CHANGE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: Number(quantity) })
    });

    const cart = await res.json();
    if (!res.ok) throw new Error(cart?.description || cart?.message || 'No se pudo actualizar el carrito');

    cartState.clear();
    cart.items.forEach(item => {
      cartState.set(String(item.variant_id), { key: item.key, quantity: item.quantity });
    });

    updateCartBubble(cart);
    return cart;
  }

  function getQtyFromUI(container){
    const input = container.querySelector('[data-qty-input]');
    const v = input ? parseInt(input.value, 10) : 0;
    return Number.isFinite(v) ? Math.max(0, v) : 0;
  }

  function scheduleCommit(container, desiredQty){
    const rules = getRules(container);
    const normalized = normalizeQty(desiredQty, rules);
    updateCardUI(container, normalized);

    const prev = debounceTimers.get(container);
    if (prev) clearTimeout(prev);

    const t = setTimeout(async () => {
      const variantId = container.getAttribute('data-variant-id');
      const current = cartState.get(String(variantId));

      // si queda 0 y no existe en carrito, no hacemos nada
      if (!current && normalized === 0) return;

      try {
        setLoading(container, true);

        if (current && current.key) {
          await changeCart(current.key, normalized);
        } else {
          // si normalized es 0, no agregamos
          if (normalized > 0) await addToCart(variantId, normalized);
        }

        const synced = cartState.get(String(variantId));
        updateCardUI(container, synced ? synced.quantity : 0);
      } catch (e) {
        await fetchCart();
        alert(e.message || 'Error actualizando el carrito');
      } finally {
        setLoading(container, false);
      }
    }, 250);

    debounceTimers.set(container, t);
  }

  // Click handlers
  document.addEventListener('click', (e) => {
    const plus = e.target.closest('[data-qty-plus]');
    const minus = e.target.closest('[data-qty-minus]');
    if (!plus && !minus) return;

    const container = e.target.closest('[data-quick-qty]');
    if (!container) return;

    const rules = getRules(container);
    const currentQty = getQtyFromUI(container);

    let desired;
    if (plus) {
      desired = currentQty === 0 ? rules.min : (currentQty + rules.inc);
    } else {
      // si está en min, baja a 0 (remueve)
      desired = currentQty <= rules.min ? 0 : (currentQty - rules.inc);
    }

    scheduleCommit(container, desired);
  });

  // Manual input
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-qty-input]');
    if (!input) return;

    const container = e.target.closest('[data-quick-qty]');
    if (!container) return;

    scheduleCommit(container, parseInt(input.value, 10) || 0);
  });

  // Init
  fetchCart().catch(() => {});
})();
